import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'ingun',
} as IModuleProps;
